import { useLocation } from 'react-router';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import msmeLogo from '@/public/images/msme_logo.svg';
import OutlookLogin from '@/src/components/common/OutlookLogin';
import lightTheme from '@/src/styles/themes/lightTheme';

const LoginPage = () => {
  const location = useLocation(); // Get location object
  const searchParams = new URLSearchParams(location.search); // Parse query parameters
  const redirectTo = searchParams.get('redirectTo') ?? '/'; // Extract redirectTo

  return (
    <Box
      className="content-center"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Card
        sx={{
          zIndex: 1,
          width: lightTheme.spacing(60),
          borderRadius: '30px'
        }}
      >
        <CardContent sx={{ padding: (theme) => `${theme.spacing(6)} !important` }}>
          <Box
            sx={{
              mb: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Box
              sx={{
                p: 3
              }}
            >
              <img src={msmeLogo} width={170} alt="MSME Logo" />
            </Box>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" fontWeight="bold">
              Please sign-in to your account
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              borderRadius: '15px'
            }}
          >
            <OutlookLogin redirectTo={redirectTo} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;
